/**
 * IANA timezone names for the tenant Timezone dropdown.
 *
 * Deliberately scoped to Asia and the Middle East — every tenant onboarded so
 * far operates in this belt, and a full ~400-zone `Intl.supportedValuesOf`
 * list mostly buries the handful anyone here will ever pick.
 */
export const IANA_TIMEZONES: readonly string[] = [
  'Asia/Kolkata',
  'Asia/Dubai',
  'Asia/Riyadh',
  'Asia/Qatar',
  'Asia/Kuwait',
  'Asia/Bahrain',
  'Asia/Muscat',
  'Asia/Baghdad',
  'Asia/Karachi',
  'Asia/Dhaka',
  'Asia/Colombo',
  'Asia/Kathmandu',
  'Asia/Yangon',
  'Asia/Bangkok',
  'Asia/Jakarta',
  'Asia/Singapore',
  'Asia/Kuala_Lumpur',
  'Asia/Manila',
  'Asia/Hong_Kong',
  'Asia/Shanghai',
  'Asia/Tokyo',
  'Asia/Seoul',
  'Asia/Istanbul',
  'Asia/Beirut',
  'Asia/Amman',
  'Asia/Jerusalem',
  'Asia/Damascus',
  'Asia/Tehran',
] as const;

/** Ensures a tenant's already-saved timezone always appears, even if it fell out of the list above. */
export function timezoneOptions(current: string): readonly string[] {
  if (!current || IANA_TIMEZONES.includes(current)) return IANA_TIMEZONES;
  return [current, ...IANA_TIMEZONES];
}
